import { handleAxiosError } from 'core/notifications';
import axios from '@/util/axios';
import getSelectOptions from './getSelectOptions';

import getAxiosConfig from './getAxiosConfig';

export default async (search) => {
  let data;

  try {
    ({
      data: { data },
    } = await axios(getAxiosConfig('get-ad-hoc-letters', { search })));
  } catch (error) {
    return handleAxiosError(error);
  }

  return getSelectOptions(data);
};
